import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createPlanesEstudioSchema = yup.object({
  nombre: yup
    .string()
    .required(DEFAULT_MESSAGES.REQUIRED)
    // fix para que acepte acentos y ñ
    .matches(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑüÜ]+$/, 'Solo se permiten letras, números y espacios'),
  descripcion: yup
    .string(),
  fecha_publicacion: yup.date().required(DEFAULT_MESSAGES.REQUIRED),
  cantidad_anios: yup.number().required(DEFAULT_MESSAGES.REQUIRED).min(1, "El mínimo de años es 1").max(99, "El máximo de años es 99"),
  alcance_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  disenio_curricular_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
  /* arr_titulos_id: yup
    .array()
    .of(yup.number().required(DEFAULT_MESSAGES.REQUIRED))
    .min(1, DEFAULT_MESSAGES.REQUIRED), */

  arr_normativas_id: yup
    .array()
    .of(yup.number().required(DEFAULT_MESSAGES.REQUIRED))
    .min(1, DEFAULT_MESSAGES.REQUIRED),

  arr_certificaciones_id: yup.array().of(yup.number().optional()),

  arr_orientaciones_id: yup.array().of(yup.number().optional()),
  arr_especialidades_id: yup.array().of(yup.number().optional()),
  arr_combinatorias_id: yup
    .array()
    .of(yup.number().required(DEFAULT_MESSAGES.REQUIRED))
    .min(1, DEFAULT_MESSAGES.REQUIRED),

  aplicaValidezNacional: yup.boolean().required(DEFAULT_MESSAGES.REQUIRED),
});
